import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { string } from "yup";
import React from 'react'
import FormikControls from './form-components/FormikControls';
import { Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { navigation3 } from '../../../utilityFunctions';
import CloseIcon from '@mui/icons-material/Close';
const OneDayPassword = ({ onSubmit, onClose = () => { }, data }) => {
    const initialValues = {
        ODP: ""
    };
    const validationSchema = Yup.object({
        ODP: string().required("Required")
    });
    return (
        <Box className='OneDayPassword'>
            <Box className="OneDayPassword--content">
                <div className='OneDayPassword-header'>
                    <LockIcon sx={{ width: '24px', height: '24px', color: '#004F9E' }} /> Enter One Day Password
                </div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, setFieldValue, submitForm }) => {
                        return (
                            <Form>
                                <div className="input--wrapper">
                                    <FormikControls
                                        control="input"
                                        type="text"
                                        id='ODP'
                                        name="ODP"
                                        label="One Day Password (ODP)"
                                        autoComplete="new-password"
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) submitForm();
                                        }}
                                    />
                                </div>
                                <div
                                    className="submit--btn"
                                    onClick={(e) => {
                                        submitForm();
                                    }}
                                    tabIndex={0}
                                    id='submit'
                                    type="submit"
                                    onKeyDown={(e) => {
                                        navigation3(e, 'ODP', 'ODP', () => { submitForm() })
                                    }}
                                >
                                    LOGIN
                                </div>
                            </Form>
                        )
                    }}

                </Formik>

            </Box>
            <Box className='OneDayPassword-rightContainer'>
                <Box >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                        <h4 style={{
                            paddingTop: '2px',
                            paddingBottom: '24px',
                        }}>Please note the following:</h4>
                        <CloseIcon onClick={onClose} />
                    </div>
                    <span style={{
                        fontSize: '14px',
                        letterSpacing: '0.02em',

                    }}>
                        {`Today's one day password has been generated.
                        E-mailed sent to ${data?.email || ''} and SMS sent to ${data?.phone || ''}.`}
                    </span>
                </Box>
            </Box>
        </Box>
    )
}

export default OneDayPassword